import React, { useState } from "react";
import portfolio from "../data/portfolio.json";

const { skills } = portfolio;

const Skills = () => {
  const [activeCat, setActiveCat] = useState(0);

  const techMarquee = [
    "TypeScript", "Angular", "React", "Next.js", "jQuery",
    "Adobe AEM", "Java/Kotlin", "Spring Boot", "REST APIs",
    "Jenkins", "Docker", "Claude Code", "Sonar", "Tailwind"
  ];

  return (
    <section id="skills" className="relative py-32 overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(800px circle at 80% 20%, rgba(94,234,212,0.06), transparent 50%)",
        }}
      />
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="flex items-center gap-4 mb-16">
          <span className="font-mono text-xs text-teal-300">02 / Skills</span>
          <div className="h-px flex-1 bg-gradient-to-r from-zinc-800 to-transparent" />
        </div>

        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <h2
              className="font-display font-bold text-white tracking-tight"
              style={{ fontSize: "clamp(2rem, 4.5vw, 3.25rem)" }}
            >
              The stack I reach for{" "}
              <span className="text-teal-300">most often</span>.
            </h2>
            <p className="mt-6 text-zinc-400 leading-relaxed">
              Frontend is where I spend most of my time. I also work with APIs,
              databases, and deployment when a project needs it.
            </p>

            <div className="mt-10 flex flex-col gap-2">
              {skills.map((cat, i) => (
                <button
                  key={i}
                  onClick={() => setActiveCat(i)}
                  className={`group text-left px-5 py-4 rounded-2xl border transition-all ${
                    activeCat === i
                      ? "bg-zinc-900/60 border-teal-300/40"
                      : "bg-transparent border-zinc-800 hover:border-zinc-700 hover:bg-white/[0.02]"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span
                      className={`font-display text-lg ${
                        activeCat === i ? "text-white" : "text-zinc-300"
                      }`}
                    >
                      {cat.category}
                    </span>
                    <span className="font-mono text-xs text-zinc-500">
                      0{i + 1}
                    </span>
                  </div>
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="glass-strong rounded-3xl p-8 gradient-border">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <div className="text-xs font-mono text-zinc-500 uppercase tracking-wider">
                    Category
                  </div>
                  <div className="font-display text-2xl text-white mt-1">
                    {skills[activeCat].category}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xs font-mono text-zinc-500">
                    {skills[activeCat].items.length} skills
                  </div>
                </div>
              </div>

              <div className="space-y-5">
                {skills[activeCat].items.map((s, i) => (
                  <div key={s.name} className="group">
                    <div className="flex items-baseline justify-between mb-2">
                      <span className="text-zinc-200 font-medium">
                        {s.name}
                      </span>
                      <span className="text-xs font-mono text-zinc-500">
                        {s.level}%
                      </span>
                    </div>
                    <div className="relative h-1.5 rounded-full bg-zinc-900 overflow-hidden">
                      <div
                        className="absolute inset-y-0 left-0 bg-gradient-to-r from-teal-400 to-teal-200 rounded-full"
                        style={{
                          width: `${s.level}%`,
                          transitionDelay: `${i * 80}ms`,
                          transition: "width 0.9s cubic-bezier(0.2,0.9,0.3,1.2)",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Tech marquee */}
        <div className="mt-20 relative overflow-hidden py-6 border-y border-zinc-900">
          <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#08090d] to-transparent z-10" />
          <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#08090d] to-transparent z-10" />
          <div className="flex marquee whitespace-nowrap">
            {[...techMarquee, ...techMarquee].map((t, i) => (
              <span
                key={i}
                className="font-display text-3xl md:text-4xl text-zinc-700 hover:text-teal-300 transition-colors mx-8"
              >
                {t}
                <span className="text-zinc-800 ml-8">•</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
